module.exports = __webpack_public_path__ + "static/media/NetReport1.0692bdba.pdf";